export class TimeZone {
  static EUROPE_BERLIN = 'Europe/Berlin';

  static getTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}
